export enum TemporaryAccesStatus {
  Unknown = 'Unknown',
  Active = 'Active',
  Expired = 'Expired',
  Revoked = 'Revoked',
}
